module.exports = __webpack_public_path__ + "static/media/iconDownload.ee53a9fc.svg";